import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IGetDiscountCodesResponse } from '../types/DiscountCode.types';
import { DISCOUNT_CODES_PATH } from './campaignApiBase';

/**
 * Every code this office has ever held, newest first, with its usage counts.
 * An office with no codes gets `{ appliedCodes: [] }` — an empty list is a
 * success, never a 404, so callers must not treat "empty" as an error.
 */
export const getDiscountCodes = async (): Promise<IGetDiscountCodesResponse> => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.get<IGetDiscountCodesResponse>(DISCOUNT_CODES_PATH, {
    headers,
  });

  return response.data;
};
